import { defineStore } from 'pinia';
import {computed, ref} from 'vue';


export const UseProductStore = defineStore('productStore', () => {

    // State variables using `ref` or `reactive`
    const selectedProducts = ref([]); // Stores checked products
    const returnReasons = ref({});    // Stores return reasons by product ID
    const productDesc = ref({});      // Stores product descriptions
    const imageNames = ref({});       // Stores image file names
    const imageUrls = ref({});
    const isChecked = ref({});
    const uploadedFiles = ref({});
    const saveDesc = ref({});
    const reasonCodeMap = ref({
        'changedMind': 'change_opinion',
        'defective': 'defect',
        'size': 'missfit',
        'wrongProduct': 'wrong_product',
        '': 'no_input',
    });
    const reasonCodes = ref({});

    // Methods (Actions)
    const toggleProduct = (product) => {
        const index = selectedProducts.value.findIndex(p => p.id === product.id);
        if (index !== -1) {
            selectedProducts.value.splice(index, 1);
            delete returnReasons.value[product.id];
            delete productDesc.value[product.id];
            delete saveDesc.value[product.id];
            delete imageNames.value[product.id];
            delete imageUrls.value[product.id];
            delete uploadedFiles.value[product.id];
        } else {
            isChecked[product.id] = true
            saveDesc[product.id] = true
            selectedProducts.value.push({ ...product });
        }
    };

    const handleReasonChange = (product) => {
        setProductDesc(product.id, "");
        setImageName(product.id, "");
        setImageUrl(product.id, "");


        // Map reason text to code
        const reasonText = returnReasons.value[product.id];
        console.log("reasonText ",reasonText)
        const code = reasonCodeMap.value[reasonText] || 'no_input';
        console.log("reasonCodeMap[reasonText] ",reasonCodeMap.value[reasonText])
        console.log("code ",code)
        reasonCodes.value[product.id] = code;
        console.log("reasonCodes.value[product.id] ",reasonCodes.value[product.id])

    };

    const lines = computed(() => { // info returned to api
        return selectedProducts.value.map(product => ({
            lineId: product.lineId,
            qty: 1,
            remarks: productDesc.value[product.id] || "",
            returnReason: reasonCodes.value[product.id]
        }));
    });

    const setReturnReason = (productId, reason) => {
        returnReasons.value[productId] = reason;
    };

    const getReturnReason = (productId) => {
        return returnReasons.value[productId] || null;
    };

    const setProductDesc = (productId, desc) => {
        productDesc.value[productId] = desc;
    };

    const getProductDesc = (productId) => {
        return productDesc.value[productId] || null;
    };

    const setImageName = (productId, imageName) => {
        imageNames.value[productId] = imageName;
    };

    const getImageName = (productId) => {
        return imageNames.value[productId] || null;
    };

    const setImageUrl = (productId, url) => {
        imageUrls.value[productId] = url;
    };

    const getImageUrl = (productId) => {
        return imageUrls.value[productId] || null;
    };


    const $reset = () => {
        selectedProducts.value = []; // Reset to empty array
        returnReasons.value = {};    // Reset to empty object
        productDesc.value = {};      // Reset to empty object
        imageNames.value = {};       // Reset to empty object
        imageUrls.value = {};       // Reset to empty object
        isChecked.value = {};        // Reset to empty object if needed
    };

    // Expose state and methods
    return {
        selectedProducts,
        returnReasons,
        productDesc,
        imageNames,
        imageUrls,
        uploadedFiles,
        isChecked,
        toggleProduct,
        handleReasonChange,
        lines,
        setReturnReason,
        getReturnReason,
        setProductDesc,
        getProductDesc,
        setImageName,
        getImageName,
        setImageUrl,
        getImageUrl,
        saveDesc,
        $reset
    };
},
    {
    persist: true
    }
);
